export interface INotesTemplatesFormDelegation {
    afterNotesTemplateSaved(): void;
    cancelNotesTemplate(): void;
}
